import { Box, Button, Heading, Layer, Text } from "grommet";
import { COLLEGE_BOARD_ISSUE_GROUPS } from "./collegeBoardIssues";

function IssueRow({ issue, onAddIssue }) {
  return (
    <Box
      flex={false}
      direction="row"
      gap="medium"
      pad={{ vertical: "small" }}
      border={{ side: "bottom", color: "light-3" }}
      align="start"
      justify="between"
    >
      <Box flex="grow" basis="0">
        <Text weight="bold">{issue.category}</Text>
        <Text size="small" margin={{ top: "xsmall" }}>
          <Text weight="bold" size="small">
            Irregularity:{" "}
          </Text>
          {issue.irregularity}
        </Text>
        <Text size="small" margin={{ top: "xsmall" }}>
          <Text weight="bold" size="small">
            Action:{" "}
          </Text>
          {issue.action}
        </Text>
      </Box>
      <Box flex={false}>
        <Button
          label="Add Issue"
          primary
          color="black"
          size="small"
          onClick={() => onAddIssue(issue.category)}
        />
      </Box>
    </Box>
  );
}

export default function CollegeBoardAddIssueLayer({ onClose, onAddIssue }) {
  return (
    <Layer
      position="center"
      modal
      onEsc={onClose}
      onClickOutside={onClose}
      margin="medium"
    >
      <Box width="large" flex={false}>
        <Box
          flex={false}
          direction="row"
          justify="between"
          align="center"
          pad={{ horizontal: "medium", vertical: "small" }}
          border={{ side: "bottom", color: "light-3" }}
        >
          <Heading level={3} margin="none">
            Add Issue
          </Heading>
          <Button label="Close" onClick={onClose} />
        </Box>

        <Box
          flex={false}
          pad="medium"
          style={{ maxHeight: "70vh", overflowY: "auto" }}
        >
          {COLLEGE_BOARD_ISSUE_GROUPS.map((group) => (
            <Box key={group.title} flex={false} margin={{ bottom: "medium" }}>
              <Heading level={4} margin={{ top: "none", bottom: "xsmall" }}>
                {group.title}
              </Heading>
              {group.issues.map((issue) => (
                <IssueRow
                  key={issue.category}
                  issue={issue}
                  onAddIssue={onAddIssue}
                />
              ))}
            </Box>
          ))}
        </Box>

        <Box
          flex={false}
          direction="row"
          justify="end"
          pad={{ horizontal: "medium", vertical: "small" }}
          border={{ side: "top", color: "light-3" }}
        >
          <Button label="Close" primary color="black" onClick={onClose} />
        </Box>
      </Box>
    </Layer>
  );
}
